import { useAuth } from '../providers/auth.provider';
import { createFileRoute } from '../utils/route-factory';

function Index() {
  const { isAuthenticated } = useAuth();
  // TODO: *** Will be updated just default
  const route = isAuthenticated ? '/dashboard' : '/sign-in';
  location.href = route;
  return null;
}

export const Route = createFileRoute({
  path: '/',
  component: Index,
  type: 'public',
});
